module.exports = __webpack_public_path__ + "img/cooperative0_logo26.f2cf24a0.jpg";